export default {
  inserted: function (el, binding) {
    if (binding.arg === 'desktop' && window.matchMedia('(min-width: 1280px)').matches) {
      el.focus();
    } else if (binding.arg === 'mobile' && window.matchMedia('(max-width: 1279px)').matches) {
      el.focus();
    } else if (typeof binding.arg === 'undefined') {
      el.focus();
    }
  }
}


// WEBPACK FOOTER //
// ./resources/assets/js/shared/directives/focus.js